import React from 'react';
import PrizesCommon from './PrizesCommon';
import PrizesBoxes from './PrizesBoxes';

const Prizes = React.forwardRef(function Prizes({ isMonth, isGamesRatingPrizes }, ref) {
  return (
    <>
      {isGamesRatingPrizes ? (
        <PrizesBoxes isGamesRatingPrizes={isGamesRatingPrizes} />
      ) : (
        <PrizesCommon isMonth={isMonth} isGamesRatingPrizes={isGamesRatingPrizes} />
      )}
    </>
  );
});
export default Prizes;
Prizes.propTypes = {};
